<template>
  <v-container
    class="main-container"
    fill-height
  >
    <v-row justify="center" align="center">
      <v-col cols="8">
        <v-card color="grey lighten-3 pa-5">            
          <v-card-title class="justify-center">Izveštaj operatera</v-card-title>

          <v-card-actions class="justify-center mt-5">
            <v-btn>Napravi izveštaj</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!--  No file chosen dialog  -->
    <v-dialog v-model="showNoChosenFileDialog" persistent width="40%">
      <v-card>
        <v-card-title class="headline">
          Obaveštenje!
        </v-card-title>
        <v-card-text>{{ message }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="showNoChosenFileDialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
    export default {
        name: "OperaterReports",
        data() {
            return{
                message: "",
                showNoChosenFileDialog: false,
            }
        },
        methods: {
            
        }
    }
</script>

